<!--
  //app/components/Shared/icons/ArrowFilterIcon.vue
  -->

<script setup lang="ts">
type Props = {
  width?: number | string;
  height?: number | string;
  showFilterItems?: boolean;
};

withDefaults(defineProps<Props>(), {
  height: 10,
  width: 10,
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    class="ml-1.5 text-gray-600"
    :class="showFilterItems ? 'rotate-180' : ''"
    aria-hidden="true"
    fill="none"
    viewBox="0 0 10 6"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="m1 1 4 4 4-4"
    />
  </svg>
</template>

<style scoped></style>
